<ng-container *ngIf="loading">
  <div>
    <div class="slds-spinner slds-spinner_medium slds-spinner_brand" role="status">
      <div class="slds-spinner__dot-a"></div>
      <div class="slds-spinner__dot-b"></div>
    </div>
    <div class="loadingMessage">
      <strong>Loading...</strong><br />
      {{ loadingMessage }}<br />
    </div>
  </div>
</ng-container>
